<template>
  <div>
    <app-header />
    <router-view/>
  </div>
</template>
<style lang="less">
  @import '../../less/common';
  @import '../../less/admin';

  body { background:#fff; }
  [header] + div { .mt(20); .ml(20); .mr(20); }
</style>
<script>
import AppHeader from './common/AppHeader.vue';

export default {
  components: { AppHeader },
};
</script>



// WEBPACK FOOTER //
// src/views/committee/template.vue